import { ISessionResumeActions, ISessionResumeState } from './sessionResume.types'
import { SessionResumeConstants } from './sessionResume.constants'

export const initialSessionResumeState: ISessionResumeState = {
  showSessionResumeModal: false,
  user: null,
}

export function sessionResumeReducer(
  state: ISessionResumeState = initialSessionResumeState,
  action: ISessionResumeActions
): ISessionResumeState {
  switch (action.type) {
    case SessionResumeConstants.SET_SESSION_RESUME_SHOW_MODAL:
      return { ...state, showSessionResumeModal: action.showSessionResumeModal }
    case SessionResumeConstants.SET_USER:
      return { ...state, user: action.user }
    case SessionResumeConstants.RESET_SESSION:
      return { ...initialSessionResumeState }
    default:
      return state
  }
}
